import React, { Component } from 'react';
import {ref} from '../../config/firebase';

export default class About extends Component {

	constructor(props) {
		super(props);
		this.state = {
            items: []
		};

		this.dbItems = ref.child('about');
	}

	componentDidMount() {
		this.dbItems.on("value", snapshot => {
			var items = [];

			items = snapshot.val();

			this.setState({items:items});

		});
	}

  render() {
    return (

      	<div className="container">
			<div className="row pt50 pb50">
				<div className="col-md-3 text-center pt20">
					<img src={this.state.items.photo} className="profile-img" width="150px" alt="" />
					<p className="pt20">
						<a className="btn btn-info" href={this.state.items.cv} target="_blank" rel="noopener noreferrer"><i className="fa fa-file-pdf-o"></i> My CV</a>
					</p>
				</div>
				<div className="col-md-9">
					<h4 className="uppercase pt20 pb20"><i className="fa fa-user-circle-o"></i> About Me</h4>
					<p>{this.state.items.description}</p>

					<h4 className="uppercase pt20 pb20"><i className="fa fa-vcard-o"></i> Personal Information</h4>
					<div className="dashed"></div>
					<div className="col-md-12 nullpadding pt20 pb20 mobile-margin">
						<div className="col-md-2 col-xs-6 col-sm-3 nullpadding"><i className="fa fa-caret-right"></i> <i className="fa fa-user-o"></i> Name</div>
						<div className="col-md-1 col-xs-1 col-sm-1 nullpadding">:</div>
						<div className="col-md-8 col-xs-12 col-sm-8 nullpadding">{this.state.items.name}</div>
					</div>
					<div className="dashed"></div>
					<div className="col-md-12 nullpadding pt20 pb20 mobile-margin">
						<div className="col-md-2 col-xs-6 col-sm-3 nullpadding"><i className="fa fa-caret-right"></i> <i className="fa fa-phone"></i> Phone</div>
						<div className="col-md-1 col-xs-1 col-sm-1 nullpadding">:</div>
						<div className="col-md-8 col-xs-12 col-sm-8 nullpadding">{this.state.items.phone}</div>
					</div>
					<div className="dashed"></div>
					<div className="col-md-12 nullpadding pt20 pb20 mobile-margin">
						<div className="col-md-2 col-xs-6 col-sm-3 nullpadding"><i className="fa fa-caret-right"></i> <i className="fa fa-envelope-o"></i> Email</div>
						<div className="col-md-1 col-xs-1 col-sm-1 nullpadding">:</div>
						<div className="col-md-8 col-xs-12 col-sm-8 nullpadding">{this.state.items.email}</div>
					</div>
					<div className="dashed"></div>
					<div className="col-md-12 nullpadding pt20 pb20 mobile-margin">
						<div className="col-md-2 col-xs-6 col-sm-3 nullpadding"><i className="fa fa-caret-right"></i> <i className="fa fa-address-book-o"></i> Address</div>
						<div className="col-md-1 col-xs-1 col-sm-1 nullpadding">:</div>
						<div className="col-md-8 col-xs-12 col-sm-8 nullpadding">{this.state.items.address}</div>
					</div>
					<div className="dashed"></div>

					<h4 className="uppercase pt20 pb20"><i className="fa fa-connectdevelop"></i> Social Media</h4>
					<div className="dashed"></div>
					<div className="col-md-12 nullpadding pt20 pb20 mobile-margin">
						<div className="col-md-2 col-xs-6 col-sm-3 nullpadding"><i className="fa fa-caret-right"></i> <i className="fa fa-whatsapp"></i> WhatsApp</div>
						<div className="col-md-1 col-xs-1 col-sm-1 nullpadding">:</div>
						<div className="col-md-8 col-xs-12 col-sm-8 nullpadding">{this.state.items.wa}</div>
					</div>
					<div className="dashed"></div>
					<div className="col-md-12 nullpadding pt20 pb20 mobile-margin">
						<div className="col-md-2 col-xs-6 col-sm-3 nullpadding"><i className="fa fa-caret-right"></i> <i className="fa fa-spinner"></i> Line</div>
						<div className="col-md-1 col-xs-1 col-sm-1 nullpadding">:</div>
						<div className="col-md-8 col-xs-12 col-sm-8 nullpadding">{this.state.items.line}</div>
					</div>
					<div className="dashed"></div>
					<div className="col-md-12 nullpadding pt20 pb20 mobile-margin">
						<div className="col-md-2 col-xs-6 col-sm-3 nullpadding"><i className="fa fa-caret-right"></i> <i className="fa fa-github"></i> Github</div>
						<div className="col-md-1 col-xs-1 col-sm-1 nullpadding">:</div>
						<div className="col-md-8 col-xs-12 col-sm-8 nullpadding"><a href={this.state.items.ig} target="_blank" rel="noopener noreferrer">andrideng</a></div>
					</div>
					<div className="dashed"></div>
					<div className="col-md-12 nullpadding pt20 pb20 mobile-margin">
						<div className="col-md-2 col-xs-6 col-sm-3 nullpadding"><i className="fa fa-caret-right"></i> <i className="fa fa-linkedin-square"></i> LinkedIn</div>
						<div className="col-md-1 col-xs-1 col-sm-1 nullpadding">:</div>
						<div className="col-md-8 col-xs-12 col-sm-8 nullpadding"><a href={this.state.items.linkedin} target="_blank" rel="noopener noreferrer">andri-deng</a></div>
					</div>
					<div className="dashed"></div>
				</div>
			</div>
		</div>

    );
  }
}



// WEBPACK FOOTER //
// ./src/guest/components/About.js